var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 634,
    viewBox: "0 0 552 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "anim-360-self",
    cx: 317,
    cy: 317,
    r: 316.5,
    fill: "white",
    stroke: "#E1E1E1",
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.863,
    cy: 316.137,
    r: 217.303,
    fill: "white",
    stroke: "#E1E1E1",
    strokeDasharray: "4 4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 317,
    r: 103.441,
    fill: "white",
    stroke: "#E1E1E1",
    strokeDasharray: "4 4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "anim-rad-360",
    cx: 60.381,
    cy: 127.663,
    r: 28.6905,
    fill: "#F7F7F7",
    stroke: "white",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "anim-rad-360",
    cx: 243.68,
    cy: 522.295,
    r: 36.0224,
    fill: "#F6F6F6",
    stroke: "white",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.68,
    cy: 522.295,
    r: 9.91973,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.544,
    cy: 146.639,
    r: 18.3395,
    fill: "#F6F6F6",
    stroke: "white",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.629,
    cy: 341.584,
    r: 13.1639,
    fill: "#F6F6F6",
    stroke: "white",
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.381,
    cy: 127.663,
    r: 6.90068,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.976,
    cy: 146.208,
    r: 4.74422,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.629,
    cy: 341.584,
    r: 2.58776,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.86c1cb35.svg";
export { ForwardRef as ReactComponent };